import { render, staticRenderFns } from "./shipmentCount.vue?vue&type=template&id=047f3c2a&"
import script from "./shipmentCount.vue?vue&type=script&lang=js&"
export * from "./shipmentCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports